import React, { createContext, useContext, ReactNode } from 'react';
import { useMoldOrderDetail } from '../hooks/useMoldOrder';

interface MoldOrderDetailContextType {
  // Mold order data and operations from the hook
  moldOrder: ReturnType<typeof useMoldOrderDetail>['moldOrder'];
  loading: ReturnType<typeof useMoldOrderDetail>['loading'];
  error: ReturnType<typeof useMoldOrderDetail>['error'];
  errorStatus: ReturnType<typeof useMoldOrderDetail>['errorStatus'];
  updateMoldOrderStatus: ReturnType<typeof useMoldOrderDetail>['updateMoldOrderStatus'];
  updateMoldOrderStateInstance: ReturnType<typeof useMoldOrderDetail>['updateMoldOrderStateInstance'];
  updateMoldOrder: ReturnType<typeof useMoldOrderDetail>['updateMoldOrder'];
  updateMoldOrderDetail: ReturnType<typeof useMoldOrderDetail>['updateMoldOrderDetail'];
  downloadPdfReport: ReturnType<typeof useMoldOrderDetail>['downloadPdfReport'];
  submitApproval: ReturnType<typeof useMoldOrderDetail>['submitApproval'];
  refetch: ReturnType<typeof useMoldOrderDetail>['refetch'];
}

const MoldOrderDetailContext = createContext<MoldOrderDetailContextType | undefined>(undefined);

interface MoldOrderDetailProviderProps {
  children: ReactNode;
}

export const MoldOrderDetailProvider: React.FC<MoldOrderDetailProviderProps> = ({
  children,
}) => {
  const moldOrderHook = useMoldOrderDetail();

  return (
    <MoldOrderDetailContext.Provider value={moldOrderHook}>
      {children}
    </MoldOrderDetailContext.Provider>
  );
};

export const useMoldOrderDetailContext = () => {
  const context = useContext(MoldOrderDetailContext);
  if (context === undefined) {
    throw new Error('useMoldOrderDetailContext must be used within a MoldOrderDetailProvider');
  }
  return context;
};
